module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.ttf?507dfa16df932802035c933c8898c0cb";